import styles from './index.module.css'

import { LuCircleCheck } from '@react-icons/all-files/lu/LuCircleCheck'
import * as React from 'react'

import { Button, Link } from 'components/ds'

export default function AddToDiscoSuccessModal({
  onClose,
  discoName,
  discoUrl,
}: {
  onClose: () => unknown
  discoName?: string
  discoUrl?: string
}): React.ReactNode {
  const discoLabel = discoName || 'your DISCO'

  return (
    <div
      className={styles.addToDiscoSuccessModalCont}
      data-testid="add-to-disco-success"
    >
      <div className={styles.addToDiscoSuccessModalTitle}>
        <LuCircleCheck color="var(--green-9)" />
        Saved
      </div>
      <div className={styles.addToDiscoSuccessModalMessage}>
        This music is being saved to{' '}
        {discoUrl ? (
          <Link href={discoUrl} target="_blank" rel="noopener noreferrer">
            {discoLabel}
          </Link>
        ) : (
          discoLabel
        )}
        <span>
          . You’ll get a notification in the app when it’s finished
          transferring.
        </span>
      </div>
      <div className={styles.addToDiscoSuccessModalCloseCont}>
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  )
}
